module.exports = __webpack_public_path__ + "static/whiteThree-2eb947070c837b84a5fe7d36027b0b12.png";